
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { VForm } from '../../global/vuetify.types'

@Component
export default class LoginForm extends Vue {
  @Prop({ type: String, default: '' })
  private readonly error!: string

  valid = false

  showPass = false

  user = {}

  passwordRules = [
    (v: string) => !!v || 'Password is required'
  ]

  emailRules = [
    (v: string) => !!v || 'Email is required',
    (v: string) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(v) || 'Invalid email format'
  ]

  get form() {
    return this.$refs.form as VForm
  }

  submit() {
    if (!this.form.validate()) {
      return
    }

    this.$emit('submit', this.user)
  }

  forgotPassword() {
    this.$emit('forgot')
  }
}
